import useMedia from 'hooks/useMedia'
import PropTypes from 'prop-types'

const FlexRowCol = ({ media, className = '', children, gap = { col: 0, row: 0 } }) => {
  FlexRowCol.propTypes = {
    media: PropTypes.string,
    className: PropTypes.string,
    gap: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  }

  const { matches } = useMedia(media)
  const flexDirection = matches ? `flex-column gap-${gap.col}` : `flex-row gap-${gap.row}`

  return <div className={`d-flex ${flexDirection} ${className}`}>{children}</div>
}

export default FlexRowCol
